// extracted by mini-css-extract-plugin
export var numberInputContainer = "_49-0";
export var startPickingButton = "_49-1";